import { render, staticRenderFns } from "./EditDelivery.vue?vue&type=template&id=00bbc88f&scoped=true&"
import script from "./EditDelivery.vue?vue&type=script&lang=ts&"
export * from "./EditDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./EditDelivery.vue?vue&type=style&index=0&id=00bbc88f&lang=scss&scoped=true&"
import style1 from "./EditDelivery.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bbc88f",
  null
  
)

export default component.exports